module.exports = __webpack_public_path__ + "img/step3.8fd2b343.png";